export const fileTypes = "video/mp4,image/jpeg,image/png,application/pdf"